const PERCENTAGE_TWO_DECIMALS_REGEX = /^(100(\.0{0,2})?|0(\.\d{0,2})?|[1-9]\d?(\.\d{0,2})?)$/;
const NUMBER_RANGE_0_9999_REGEX = /^(?:0|[1-9][0-9]{0,3})$/;

/**
 * Returns a numeric validation regex based on the specified type.
 * percentage → matches values from 0 to 100 with up to two decimal places
 * integer → matches whole numbers from 0 to 9999
 * @param type Input type to determine which regex to return.
 * @returns A RegExp for validation.
 */
export function getFlowsheetCareElementValidationRegex(type: "percentage" | "integer"): RegExp {
    return type === "percentage"
        ? PERCENTAGE_TWO_DECIMALS_REGEX
        : NUMBER_RANGE_0_9999_REGEX;
}
